import { render } from "./Unfound.vue?vue&type=template&id=59a6e215"
const script = {}
script.render = render

export default script